import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { TIPS_IFRAME_URL } from '../../constants';
import Iframe from 'components/Iframe/Iframe';
import Media from 'react-media';
import styles from 'theme';

function Tips() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Media query={{ maxWidth: styles.mq.large }}>
      {matches => (
        <Iframe
          src={TIPS_IFRAME_URL}
          height={matches ? 'calc(100vh - 145px)' : '100%'}
        />
      )}
    </Media>
  );
}

export default observer(Tips);
